export default "__VITE_ASSET__MPoOeM5K__"